import React, { useEffect, useState } from 'react';

const TRANSACTIONS = [
  { group: 'Today', items: [
    { initials: 'AF', name: 'Ahmad Feroz Noori', time: '13:44', amount: '+ ؋ 34' },
    { initials: 'MD', name: 'Mohammad Daud', time: '17:22', amount: '- ؋ 1,220' },
    { initials: 'AK', name: 'Ahmad Khan', time: '22:30', amount: '+ ؋ 90' },
  ]},
  { group: 'February 22, 2026', items: [
    { initials: 'MM', name: 'Mujtaba', time: '07:40', amount: '+ ؋ 423' },
    { initials: 'SF', name: 'Shamima', time: '13:40', amount: '+ ؋ 6,503' },
    { initials: 'KM', name: 'Khadija', time: '15:40', amount: '- ؋ 8,220' },
  ]},
];

export default function PhoneMockup() {
  const [time, setTime] = useState('');

  useEffect(() => {
    const update = () => {
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      setTime(`${h}:${m}`);
    };
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="phone-container">
      <div className="phone-frame">
        <div className="camera-notch">
          <div className="camera-circle"></div>
        </div>
        <div className="phone-screen" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

          {/* ── Purple header ── */}
          <div style={{ background: 'var(--primary-purple, #7C3AED)', color: '#fff', padding: '10px 14px 16px', flexShrink: 0 }}>

            {/* Status bar */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, fontSize: 11 }}>
              <span style={{ fontWeight: 400 }}>{time}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <span style={{ letterSpacing: 1, fontSize: 9 }}>•••</span>
                {/* wifi */}
                <svg width="13" height="10" viewBox="0 0 24 18" fill="white">
                  <path d="M12 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0-4a7 7 0 0 1 5 2.1l-1.5 1.5A5 5 0 0 0 12 12a5 5 0 0 0-3.5 1.6L7 12.1A7 7 0 0 1 12 10zm0-4a11 11 0 0 1 7.8 3.2l-1.5 1.5A9 9 0 0 0 12 8a9 9 0 0 0-6.3 2.7L4.2 9.2A11 11 0 0 1 12 6zm0-4C16.8 2 21.1 3.9 24 7l-1.5 1.5A13.9 13.9 0 0 0 12 4 13.9 13.9 0 0 0 1.5 8.5L0 7A16 16 0 0 1 12 2z"/>
                </svg>
                {/* battery */}
                <svg width="18" height="10" viewBox="0 0 24 12" fill="white">
                  <rect x="0" y="1" width="21" height="10" rx="2" stroke="white" strokeWidth="1.5" fill="none"/>
                  <rect x="21" y="4" width="3" height="4" rx="1" fill="white"/>
                  <rect x="1.5" y="2.5" width="17" height="7" rx="1" fill="white"/>
                </svg>
              </div>
            </div>

            {/* User row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/icons/avatar.png" alt="User" width="20" height="20" style={{ borderRadius: '50%', objectFit: 'cover' }} />
                </div>
                <span style={{ fontWeight: 500, fontSize: 14 }}>Mustafa</span>
                <svg width="10" height="6" viewBox="0 0 10 6" fill="white"><path d="M0 0l5 6 5-6z"/></svg>
              </div>
              <div style={{ display: 'flex', gap: 12 }}>
                {/* message */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                {/* bell */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
              </div>
            </div>

            {/* Currency selector */}
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 15, opacity: 0.85, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                 ؋ (AFN)
                <svg width="8" height="5" viewBox="0 0 10 6" fill="white"><path d="M0 0l5 6 5-6z"/></svg>
              </span>
            </div>

            {/* Balance */}
            <div style={{ textAlign: 'center', fontSize: 38, fontWeight: 500, lineHeight: 1, marginBottom: 4 }}>734</div>
            <div style={{ textAlign: 'center', fontSize: 11, opacity: 0.8, marginBottom: 14 }}>Available Balance</div>

            {/* Add Money */}
            <button type="button" style={{ width: '100%', border: '1.5px solid rgba(255,255,255,0.8)', borderRadius: 50, padding: '8px 0', background: 'transparent', color: '#fff', fontWeight:400, fontSize: 13, cursor: 'pointer' }}>
              Add Money
            </button>
          </div>

          {/* ── Quick actions ── */}
          <div style={{ background: '#fff', display: 'flex', justifyContent: 'space-around', padding: '14px 10px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 }}>
            {[
              { label: 'Send', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" fill="#EEF2FF"/><path d="M8 12h8M14 8l4 4-4 4" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> },
              { label: 'Receive', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" fill="#FFF7ED"/><rect x="9" y="6" width="6" height="9" rx="1" fill="#F97316"/><path d="M9 11h6" stroke="white" strokeWidth="1.2"/><circle cx="12" cy="8" r="1" fill="white"/></svg> },
              { label: 'Withdraw', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" fill="#EFF6FF"/><rect x="7" y="8" width="10" height="8" rx="1.5" stroke="#2563EB" strokeWidth="1.5"/><rect x="9" y="11" width="4" height="2.5" rx="0.5" fill="#2563EB"/></svg> },
            ].map(({ label, icon }) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: 4 }}>{icon}</div>
                <div style={{ fontSize: 11, color: '#374151' }}>{label}</div>
              </div>
            ))}
          </div>

          {/* ── Transactions ── */}
          <div className="phone-tx-scroll" style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none', background: '#f9fafb', padding: '12px 14px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ fontWeight: 500, fontSize: 13, color: '#111827' }}>Transactions</span>
              <span style={{ fontSize: 14, color: '#6B7280' }}>→</span>
            </div>

            {TRANSACTIONS.map(({ group, items }) => (
              <div key={group}>
                <div style={{ fontSize: 11, color: '#9CA3AF', marginBottom: 6, marginTop: 6 }}>{group}</div>
                {items.map((tx, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, background: '#fff', borderRadius: 10, padding: '8px 10px' }}>
                    <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#D1FAE5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#065F46', flexShrink: 0 }}>
                      {tx.initials}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 11, fontWeight: 400, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{tx.name}</div>
                      <div style={{ fontSize: 10, color: '#9CA3AF' }}>{tx.time}</div>
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 400, color: '#16A34A', flexShrink: 0 }}>{tx.amount.startsWith('+') && tx.amount}</div>
                    <div style={{ fontSize: 12, fontWeight: 400, color: '#f70202', flexShrink: 0 }}>{tx.amount.startsWith('-') && tx.amount}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* ── Bottom nav ── */}
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '8px 10px', background: '#fff', borderTop: '1px solid #f0f0f0', flexShrink: 0 }}>
            {/* Home */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--primary-purple, #7C3AED)"><path d="M3 12L12 3l9 9v9H15v-5H9v5H3z"/></svg>
            {/* Chart */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2"><path d="M12 2a10 10 0 1 0 10 10H12z"/><path d="M12 2v10l7 3"/></svg>
            {/* QR - center floating */}
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'var(--primary-purple, #7C3AED)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: -16, boxShadow: '0 2px 8px rgba(124,58,237,0.4)' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="3" height="3"/><rect x="19" y="14" width="2" height="2"/><rect x="14" y="19" width="2" height="2"/><rect x="19" y="19" width="2" height="2"/></svg>
            </div>
            {/* Messages */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            {/* Profile */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
          </div>

        </div>
      </div>
    </div>
  );
}
